module.exports = __webpack_public_path__ + "static/media/cert_60years.93fa76c1.jpg";